import { useFormContext, Controller, useFieldArray } from 'react-hook-form';
import { styled } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import GoogleCategoriesForm from '@features/GoogleCategoriesForm';
import { Input } from '@components/Input';
import { DeleteIcon } from 'assets/images/icons';
import { useTranslation } from '@hooks';

const Form = styled('div')({
    maxWidth: 698,
    display: 'grid',
    gridTemplateColumns: 'calc(50% - 8px) calc(50% - 8px)',
    gap: '16px',
    '@media (max-width: 1024px)': {
        maxWidth: 'none',
        gridTemplateColumns: '100%',
    },
});

const StyledIconButton = styled(IconButton)({
    position: 'absolute',
    right: '-40px',
    top: '5px',
    padding: '4px',
    width: 32,
    height: 32,
    '& svg path': {
        fill: 'rgba(0, 0, 0, 0.6)',
    },
});

const ServiceWrapper = styled('div')({
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    gap: '8px',
    width: 'calc(100% - 40px)',
});

const StyledGoogleCategoriesForm = styled(GoogleCategoriesForm)({
    alignContent: 'flex-start',
});

const CategoriesAndServices = () => {
    const { t } = useTranslation();
    const { control } = useFormContext();

    const { fields, append, remove } = useFieldArray({
        control,
        name: 'services',
    });

    return (
        <Form>
            <StyledGoogleCategoriesForm fieldsName="secondaryCategories" required={false} />
            <div style={{ display: 'flex', gap: '8px', flexFlow: 'column' }}>
                {fields.map((field, index) => {
                    return (
                        <ServiceWrapper key={`services-${index}-${field.id || 'empty'}`}>
                            <Controller
                                control={control}
                                name={`services.${index}.name`}
                                render={({ field, ref }) => (
                                    <Input
                                        ref={ref}
                                        inputProps={{ ...field, onChange: e => field.onChange(e.target.value) }}
                                        label={`${t('common.service')} ${index + 1}`}
                                    />
                                )}
                            />
                            {index === 0 && fields.length < 4 && (
                                <StyledIconButton
                                    sx={{ right: '-42px', top: '3px' }}
                                    onClick={() => {
                                        if (fields.length < 4) {
                                            append({ name: '' });
                                        }
                                    }}
                                >
                                    <AddIcon />
                                </StyledIconButton>
                            )}
                            {index > 0 && (
                                <StyledIconButton onClick={() => remove(index)}>
                                    <DeleteIcon />
                                </StyledIconButton>
                            )}
                        </ServiceWrapper>
                    );
                })}
            </div>
        </Form>
    );
};

export default CategoriesAndServices;
